import { useDispatch } from 'react-redux';
import { getStudentsProfileForCRD } from '../../../../../redux/features/CRDslice';
import { useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import SectionCard from './ProfilSectionCard';
import { academicDetails, courseDetails, personalDetails } from '../utils/cardSectionJson';
import { useSelector } from 'react-redux';
import Loader from '../../../../../components/Loader/Loader';

export default function StudentProfileView({ id }) {
  const loading = useSelector((state) => state.crd.loading);
  const studentProfile = useSelector((state) => state.crd.studentProfile);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getStudentsProfileForCRD(id));
  }, [id, dispatch]);
  const sectionCardMapper = useMemo(() => [personalDetails, academicDetails, courseDetails], []);
  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', p: 2 }}>
      {loading ? (
        <Loader />
      ) : (
        sectionCardMapper.map(({ title, mapData }, i) => (
          <SectionCard title={personalDetails.title} mapper={mapData} data={studentProfile} key={i} />
        ))
      )}
    </Box>
  );
}
